import React from 'react';
import { Route, withRouter } from 'react-router';
import MarutiList from "./components/marutiList";
import { Container } from 'semantic-ui-react'
import OldSyncPullForm from './components/oldSyncPullForm';


const TxnSync = () => {
    return (
        <div>
            <Route path="/txnsync" component={withRouter(MarutiList)} />
            <Route path="/oldsync" component={OldSyncPullForm} />
        </div>
    )
};

export default TxnSync;

